export const STATIC_HEADER_ID = "static-header";

export const scrollToStaticHeader = (offset = 92) => {
  if (import.meta.server) {
    return;
  }

  const staticHeader = document.getElementById(STATIC_HEADER_ID);

  if (!staticHeader) {
    return;
  }

  const y = staticHeader.getBoundingClientRect().top + window.scrollY - offset;
  window?.scrollTo({
    top: y,
  });
};
